var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndividualOffer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 575,
    height: 448.931,
    viewBox: "0 0 575 448.931",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "individual-offer",
    transform: "translate(-100 -1380)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_631",
    "data-name": "Path 631",
    d: "M2.5,1506.965S0,1556.828,387.19,1524.657c0,0,54.8,2.841,134.927-4.825,92.438-8.849,38.026-33.745,26.366-34.892,0,0-43.313-11.66-200.028-11.66-153.536,0-167.771.147-167.771.147S-24.843,1473.183,2.5,1506.965Z",
    transform: "translate(100.004 293.461)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_632",
    "data-name": "Path 632",
    d: "M1967.54,820.288s-7.048-.507-6.4,15.3,2.263,24.227,2.263,24.227-.207,3.5-2.921,2.817-7.82-4.1-10.343-1.549c-2.625,2.643-1.685,6.7,1.782,11.477s10.686,15.525,11.335,16.5.9,2.748-1.029,2.575-14.913-4.573-16.632,1.714,10.13,18.008,11.4,19.315,1.339,2.131.825,2.922-4.744-1.1-8.489-2.2-8.28-1.72-8.967,1.99,4.531,14.572,24.079,25.988l9.406,4.7,8.9-5.678c18.309-13.311,22.418-24.641,21.36-28.264s-5.513-2.552-9.122-1.084-7.633,3.775-8.224,3.04-.606-1.562.525-2.987,11.752-14.275,9.413-20.36-14.821-.4-16.719-.039-1.824-1.446-1.284-2.462,6.652-12.448,9.626-17.548,3.494-9.227.628-11.6c-2.765-2.284-7.5,1.62-10.135,2.575s-3.19-2.51-3.19-2.51.764-8.539-.173-24.332-8.064-14.517-8.064-14.517",
    transform: "translate(-1330.969 775.057)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_638",
    "data-name": "Path 638",
    d: "M1987.12,1206.23a4.543,4.543,0,0,1,.827.4l2.189,1.207c1.837,1.032,4.371,2.481,7.153,4.1s5.292,3.1,7.088,4.2l2.132,1.313a4.527,4.527,0,0,1,.756.525,4.194,4.194,0,0,1-.827-.4l-2.189-1.207c-1.838-1.032-4.371-2.481-7.153-4.1s-5.292-3.1-7.1-4.2l-2.132-1.312A4.232,4.232,0,0,1,1987.12,1206.23Z",
    transform: "translate(-1365.492 490.41)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_640",
    "data-name": "Path 640",
    d: "M2043.12,1311.16H2017.1l8.492,64.282h9.036Z",
    transform: "translate(-1387.603 413.024)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_647",
    "data-name": "Path 647",
    d: "M1779.14,321.01v52.338h-75.171l-2.709-51.97Z",
    transform: "translate(-1154.672 1143.256)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_131",
    "data-name": "Rectangle 131",
    width: 51.86,
    height: 75.171,
    transform: "translate(546.588 1516.494) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_648",
    "data-name": "Path 648",
    d: "M1775.79,373.624H1699.9V321.05h75.89Zm-75.171-.714h74.457V321.764h-74.462Z",
    transform: "translate(-1153.669 1143.227)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_132",
    "data-name": "Rectangle 132",
    width: 58.887,
    height: 38.974,
    transform: "translate(554.729 1471.076)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_649",
    "data-name": "Path 649",
    d: "M1790.642,346.491h-1.126l-3.234.021-12.135.045-42.389.084.168-.171c0,11.91,0,25.1.016,38.971h0l-.183-.186,58.885.037-.147.15c.032-11.863.06-21.586.079-28.35.016-3.384.029-6.038.037-7.841q0-1.341.016-2.061c0-.467.016-.717.016-.717s0,.228.018.685,0,1.15.016,2.032c0,1.806.021,4.439.037,7.809.018,6.794.045,16.551.079,28.45v.155h-.15l-58.885.037h-.187v-.189c0-13.868,0-27.061.016-38.971v-.171h.17l42.5.081,12.1.047,3.2.021h.817A2.248,2.248,0,0,1,1790.642,346.491Z",
    transform: "translate(-1177.025 1124.598)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_650",
    "data-name": "Path 650",
    d: "M1701.255,321.841a6.4,6.4,0,0,1,1.291.837c.767.554,1.817,1.344,2.948,2.25s2.126,1.761,2.824,2.4a6.161,6.161,0,0,1,1.076,1.1c-.068.081-1.877-1.41-4.134-3.213A40.806,40.806,0,0,1,1701.255,321.841Z",
    transform: "translate(-1154.667 1142.646)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_651",
    "data-name": "Path 651",
    d: "M1964.7,322.4a38.417,38.417,0,0,1-3.956,3.368,33.011,33.011,0,0,1-4.2,3.074,36.982,36.982,0,0,1,3.956-3.365A34.2,34.2,0,0,1,1964.7,322.4Z",
    transform: "translate(-1342.94 1142.233)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_652",
    "data-name": "Path 652",
    d: "M1963.842,500.914l-8.382-6.794",
    transform: "translate(-1342.144 1015.588)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_653",
    "data-name": "Path 653",
    d: "M1955.456,494.111a78.469,78.469,0,0,1,8.381,6.794,78.382,78.382,0,0,1-8.381-6.794Z",
    transform: "translate(-1342.14 1015.597)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_654",
    "data-name": "Path 654",
    d: "M1701.256,502.085a35.1,35.1,0,0,1,3.914-3.331,36.7,36.7,0,0,1,4.145-3.042,35.669,35.669,0,0,1-3.914,3.334A36.936,36.936,0,0,1,1701.256,502.085Z",
    transform: "translate(-1154.668 1014.417)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_133",
    "data-name": "Rectangle 133",
    width: 13.049,
    height: 37.052,
    transform: "translate(566.686 1496.271) rotate(-90)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_134",
    "data-name": "Rectangle 134",
    width: 67.687,
    height: 112.039,
    transform: "translate(366.718 1380)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_135",
    "data-name": "Rectangle 135",
    width: 67.687,
    height: 112.039,
    transform: "translate(364.469 1380)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_136",
    "data-name": "Rectangle 136",
    width: 61.922,
    height: 107.495,
    transform: "translate(367.351 1382.273)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_137",
    "data-name": "Rectangle 137",
    width: 38.076,
    height: 79.557,
    transform: "translate(379.14 1396.241)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_655",
    "data-name": "Path 655",
    d: "M1063.367,175.231c-.089-7.431,6.594-14.687,13.952-15.724,3.51-.493,7.237.2,10.519-1.142,5.851-2.4,7.715-10.177,13.606-12.485l.262,57.5h-38.339Z",
    transform: "translate(-684.228 1272.414)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_656",
    "data-name": "Path 656",
    d: "M1232.489,517.63,1282.64,545.4l-1.888,3.541-49.7-28.293,1.438-3.014",
    transform: "translate(-807.895 998.25)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_657",
    "data-name": "Path 657",
    d: "M1227.14,497.706l2.3-3.525,1.341.824-2.066,3.562Z",
    transform: "translate(-805.011 1015.544)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_658",
    "data-name": "Path 658",
    d: "M1378.357,606.68l2.576,1.483-8.4,53.582-3.972.05Z",
    transform: "translate(-909.307 932.576)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_659",
    "data-name": "Path 659",
    d: "M1324.53,821.544s6.114-6.185,14.307-5.731a17.757,17.757,0,0,1,12.39,5.7Z",
    transform: "translate(-876.835 778.359)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_660",
    "data-name": "Path 660",
    d: "M1171.534,523.943l-19.854-11.464,5.731-9.928a11.461,11.461,0,0,1,15.658-4.2h0a11.461,11.461,0,0,1,4.2,15.658Z",
    transform: "translate(-749.359 1013.601)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_138",
    "data-name": "Rectangle 138",
    width: 63.623,
    height: 3.095,
    transform: "translate(308.038 1597.277) rotate(180)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_661",
    "data-name": "Path 661",
    d: "M693.68,702.06l11.934-44.72H655.935l-10.8,44.72Z",
    transform: "translate(-375.78 895.214)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_662",
    "data-name": "Path 662",
    d: "M656.47,704.481h44.379l10.33-39.271H666.571Z",
    transform: "translate(-384.144 889.41)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_139",
    "data-name": "Rectangle 139",
    width: 3.213,
    height: 153.405,
    transform: "translate(231.812 1606.438)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140",
    "data-name": "Rectangle 140",
    width: 3.213,
    height: 152.964,
    transform: "translate(235.025 1606.877)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141",
    "data-name": "Rectangle 141",
    width: 3.213,
    height: 153.405,
    transform: "translate(429.764 1606.438)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_142",
    "data-name": "Rectangle 142",
    width: 3.213,
    height: 152.964,
    transform: "translate(432.977 1606.877)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_143",
    "data-name": "Rectangle 143",
    width: 244.06,
    height: 12.582,
    transform: "translate(217.941 1597.524)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_144",
    "data-name": "Rectangle 144",
    width: 107.443,
    height: 20.824,
    transform: "translate(323.927 1610.108)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_663",
    "data-name": "Path 663",
    d: "M1062.474,904.047a2.4,2.4,0,1,1-2.4-2.4A2.4,2.4,0,0,1,1062.474,904.047Z",
    transform: "translate(-680.034 715.036)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_664",
    "data-name": "Path 664",
    d: "M309.68,1146.1h42.2a5.376,5.376,0,0,0,5.376-5.378v-13a9.062,9.062,0,0,0-9.059-9.062H309.36Z",
    transform: "translate(-128.151 554.992)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_665",
    "data-name": "Path 665",
    d: "M224.059,1231.377H141.077a4.087,4.087,0,0,1-4.077-4.09h0a4.087,4.087,0,0,1,4.09-4.087h82.97a4.087,4.087,0,0,1,4.087,4.087h0A4.087,4.087,0,0,1,224.059,1231.377Z",
    transform: "translate(-1.036 477.895)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_666",
    "data-name": "Path 666",
    d: "M57.828,805.889l45.647-.808L132.455,914.6l-61.793.619L47.354,819.208a10.776,10.776,0,0,1,10.474-13.32Z",
    transform: "translate(65.302 786.256)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_667",
    "data-name": "Path 667",
    d: "M136.358,1254.35,122.7,1333.731h3.741L144.4,1254.35Z",
    transform: "translate(9.51 454.922)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_668",
    "data-name": "Path 668",
    d: "M256.626,1254.35l-14.516,79.381h3.743l18.814-79.381Z",
    transform: "translate(-78.555 454.922)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_669",
    "data-name": "Path 669",
    d: "M410.491,1254.35l16.194,79.381h-3.741L402.45,1254.35Z",
    transform: "translate(-196.805 454.922)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_670",
    "data-name": "Path 670",
    d: "M242.11,805.08,264.7,914.715h17.325l-18.113-96.864a15.6,15.6,0,0,0-15.341-12.76Z",
    transform: "translate(-78.555 786.256)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_145",
    "data-name": "Rectangle 145",
    width: 2.336,
    height: 20.861,
    transform: "translate(161.498 1490.559)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_146",
    "data-name": "Rectangle 146",
    width: 2.336,
    height: 20.861,
    transform: "translate(238.335 1490.559)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147",
    "data-name": "Rectangle 147",
    width: 97.714,
    height: 8.387,
    transform: "translate(152.888 1482.172)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148",
    "data-name": "Rectangle 148",
    width: 13.472,
    height: 62.786,
    transform: "translate(217.826 1419.386)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_671",
    "data-name": "Path 671",
    d: "M470.709,324.34a2.667,2.667,0,1,1-.781-1.889A2.67,2.67,0,0,1,470.709,324.34Z",
    transform: "translate(-243.208 1142.77)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149",
    "data-name": "Rectangle 149",
    width: 4.124,
    height: 25.66,
    transform: "translate(222.656 1436.018)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150",
    "data-name": "Rectangle 150",
    width: 13.472,
    height: 62.786,
    transform: "translate(204.142 1419.386)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_672",
    "data-name": "Path 672",
    d: "M418.569,324.34a2.67,2.67,0,1,1-2.667-2.67A2.67,2.67,0,0,1,418.569,324.34Z",
    transform: "translate(-204.755 1142.77)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151",
    "data-name": "Rectangle 151",
    width: 4.121,
    height: 25.66,
    transform: "translate(208.972 1436.018)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_152",
    "data-name": "Rectangle 152",
    width: 13.472,
    height: 62.786,
    transform: "translate(191.11 1419.386)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_673",
    "data-name": "Path 673",
    d: "M368.939,324.34a2.67,2.67,0,1,1-2.67-2.67A2.67,2.67,0,0,1,368.939,324.34Z",
    transform: "translate(-168.152 1142.77)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_153",
    "data-name": "Rectangle 153",
    width: 4.121,
    height: 25.66,
    transform: "translate(195.94 1436.018)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_674",
    "data-name": "Path 674",
    d: "M266.768,223.52l16.186-55.231-5.581-2.449-16.6,55.68Z",
    transform: "translate(-92.316 1257.694)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_675",
    "data-name": "Path 675",
    d: "M1836.854,1297.26s-8.033-9.369-.5-15.32c0,0,5.512-3.334,9.993-3.064,0,0-6.361,10.666-4.3,11.726s6.229-12.4,6.229-12.4,12.524-1.213,16.556.725c0,0-10.71,8.762-8.455,9.284s13.823-8.079,13.823-8.079,11.658,1.982,11.025,9.1-4.638,9.308-6.405,9.119-12.093-4.131-12.317-2.685,5.99,6.174,10.345,6.395c0,0-8.222,9.064-13.682,6.447s-5.93-6.762-9.335-8.316-6.3-1.551-4.906.034,7.568,3.129,9.516,6.563,3.693,5.775-1.959,4.917-14.837-4.987-15.241-9.712Z",
    transform: "translate(-1251.928 437.604)",
    fill: "#599dad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_676",
    "data-name": "Path 676",
    d: "M1866.18,1321.846s-31.666-1.221-38.656,7.836a22.96,22.96,0,0,1-6.3,8.849l-.743,2.021s5.487-5.775,7.45-6.135C1827.925,1334.414,1824.856,1323.195,1866.18,1321.846Z",
    transform: "translate(-1242.596 405.184)",
    fill: "#599dad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_677",
    "data-name": "Path 677",
    d: "M1802.869,1383.312a19.879,19.879,0,0,0-7.269,14.007l1.234.111s2.171-9.288,6.093-12.918S1802.869,1383.312,1802.869,1383.312Z",
    transform: "translate(-1224.247 360.4)",
    fill: "#599dad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_678",
    "data-name": "Path 678",
    d: "M1608.717,1214.06s12.776-7.153,6.825-16.863c0,0-4.77-5.961-9.881-7.494,0,0,2.727,14.48,0,14.821s-1.872-16.354-1.872-16.354-13.459-6.471-18.738-5.962c0,0,8.345,14.139,5.62,13.8s-12.093-14.648-12.093-14.648-13.8-2.556-16.013,5.62,1.362,12.264,3.412,12.776,15.159.339,14.819,2.042-9.188,4.429-14.139,2.888c0,0,5.452,13.456,12.6,12.776s9.369-5.111,13.8-5.452,7.665.853,5.45,2.045-9.713.391-13.286,3.431-6.473,4.917.171,6.279,18.564.51,20.951-4.6Z",
    transform: "translate(-1051.87 509.033)",
    fill: "#6bb7bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_679",
    "data-name": "Path 679",
    d: "M1588.51,1213.51s35.769,11.584,39.856,24.528a27.134,27.134,0,0,0,3.413,12.435v2.554s-3.746-8.686-5.791-9.878C1625.983,1243.149,1633.989,1231.906,1588.51,1213.51Z",
    transform: "translate(-1071.52 485.041)",
    fill: "#6bb7bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_680",
    "data-name": "Path 680",
    d: "M1748.5,1349.852a23.582,23.582,0,0,1,2.362,18.572l-1.417-.38s1.378-11.23-1.51-16.879S1748.5,1349.852,1748.5,1349.852Z",
    transform: "translate(-1188.245 385.662)",
    fill: "#6bb7bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_681",
    "data-name": "Path 681",
    d: "M1786.665,1146.852s-16.84-9.432-8.983-22.229c0,0,6.3-7.859,13.023-9.88,0,0-3.591,19.087,0,19.535s2.47-21.554,2.47-21.554,17.738-8.534,24.7-7.86c0,0-11,18.638-7.411,18.186s15.942-19.31,15.942-19.31,18.187-3.368,21.106,7.411-1.8,16.165-4.492,16.84-19.982.449-19.533,2.693,12.125,5.838,18.637,3.817c0,0-7.184,17.74-16.613,16.84s-12.338-6.736-18.186-7.185-10.1,1.124-7.187,2.7,12.8.525,17.514,4.523,8.531,6.479-.223,8.274-24.473.675-27.618-6.061Z",
    transform: "translate(-1209.492 566.363)",
    fill: "#86d1cd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_682",
    "data-name": "Path 682",
    d: "M1857.689,1146.2s-47.151,15.267-52.537,32.333a35.839,35.839,0,0,1-4.491,16.391v3.368s4.94-11.453,7.634-13.022C1808.294,1185.261,1797.741,1170.45,1857.689,1146.2Z",
    transform: "translate(-1227.979 534.682)",
    fill: "#6bb7bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_683",
    "data-name": "Path 683",
    d: "M1788.289,1325.923s-7.272,11.041-3.127,24.481l1.871-.5s-1.817-14.805,1.987-22.25S1788.289,1325.923,1788.289,1325.923Z",
    transform: "translate(-1215.607 403.682)",
    fill: "#6bb7bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_684",
    "data-name": "Path 684",
    d: "M1722.927,1443.436a32.986,32.986,0,0,0,32.986-32.986H1689.94a32.986,32.986,0,0,0,32.986,32.986Z",
    transform: "translate(-1146.324 339.798)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_685",
    "data-name": "Path 685",
    d: "M1742.344,1443.185a33.013,33.013,0,0,1-37.084-32.734h8.2a32.991,32.991,0,0,0,28.887,32.734Z",
    transform: "translate(-1157.622 339.798)",
    fill: "#ffc294"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_686",
    "data-name": "Path 686",
    d: "M1755.094,1531.072H1688.21a4.071,4.071,0,0,1,4.069-4.071h58.746A4.072,4.072,0,0,1,1755.094,1531.072Z",
    transform: "translate(-1145.048 253.843)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_154",
    "data-name": "Rectangle 154",
    width: 67.807,
    height: 1.011,
    transform: "translate(542.532 1750.248)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_691",
    "data-name": "Path 691",
    d: "M1557.94,1350s-11.046,7.088-9.975,9.4c.144.307,6.247,11.243,6.247,11.243l7.875,13.912s3.313-1.969,1.746-6.447-2.512-12.907,1.5-18.375C1569.553,1353.938,1557.94,1350,1557.94,1350Z",
    transform: "translate(-1041.563 384.38)",
    fill: "#163560"
  }), /*#__PURE__*/React.createElement("g", {
    id: "mike"
  }, /*#__PURE__*/React.createElement("g", {
    id: "left-hand"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_688",
    "data-name": "Path 688",
    d: "M1685.872,902.16s7.547,4.289,9.66,4.289,10.406-1.6,12.718-.42,6.495,5.932,7.279,7.484c1.412,2.793-5.683,1.559-9.035-.819a2.1,2.1,0,0,0-1.662-.339c-1.738.378-5.347,1.034-7.088.388-2.341-.866-14.684-1.838-14.684-1.838Z",
    transform: "translate(-1141.25 714.66)",
    fill: "#e49963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_689",
    "data-name": "Path 689",
    d: "M1475,657.689s7.825,55.606,20.78,60.586c6.392,2.457,34.651,8.027,43,8.586,0,0,2.047-1.659,1.548-8.418,0,0-29.6-10.868-33.8-16.777-6.258-8.794,3.885-35.929-3.967-44.19S1481.487,645.666,1475,657.689Z",
    transform: "translate(-987.807 900.682)",
    fill: "#ed7d2b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "left-leg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_687",
    "data-name": "Path 687",
    d: "M1726.27,1480.766s.814,13.107,3.35,13.293c.336.026,12.863.026,12.863.026l15.986-.092s-.105-3.853-4.778-4.667-12.5-4.1-15.325-10.274C1735.387,1472.555,1726.27,1480.766,1726.27,1480.766Z",
    transform: "translate(-1173.117 291.049)",
    fill: "#163560"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_690",
    "data-name": "Path 690",
    d: "M1457.022,1034.033a97.736,97.736,0,0,0,7.641,10.933c8.4,10.616,17.562,19.368,19.163,27.642a37.084,37.084,0,0,0,1.478,5.295c.667,1.9,1.488,3.888,2.438,5.949a183.147,183.147,0,0,0,14.233,24.328c9.209,13.651,17.869,25.035,17.869,25.035l15.884-.677c-.638-1.591-7.563-20.434-16.832-43.463-3.761-9.348-7.762-19.291-11.624-28.875q-.772-1.922-1.538-3.82c-1.181-2.935-2.341-5.822-3.475-8.636l-15.632-38.85s-34.776-13.175-38.389-4.638C1445.257,1011.3,1447.683,1018.194,1457.022,1034.033Z",
    transform: "translate(-967.183 641.488)",
    fill: "#599dad"
  })), /*#__PURE__*/React.createElement("g", {
    id: "neck"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_694",
    "data-name": "Path 694",
    d: "M1513.464,598.359c-10.458,2.7-27.794-6.985-27.794-6.985a25.669,25.669,0,0,0,9.224-14.464c.128-.5.241-1.013.344-1.541l5.371-1.139,7.985,7.158a69.21,69.21,0,0,1-1.181,8.077q-.263,1.339-.6,2.867A24.607,24.607,0,0,1,1513.464,598.359Z",
    transform: "translate(-995.676 956.507)",
    fill: "#e49963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_697",
    "data-name": "Path 697",
    d: "M1534.5,581.389a69.12,69.12,0,0,1-1.181,8.077c-7.8-2.52-11.337-9.566-12.521-12.556.129-.5.241-1.013.344-1.541l5.371-1.139Z",
    transform: "translate(-1021.584 956.507)",
    fill: "#d68d5d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "right-leg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_692",
    "data-name": "Path 692",
    d: "M1488.772,1110s-6.9-6.09-8.122-10.555c0,0,28.45-34.086,34.622-41.738.281-.349.21-.735-.162-1.155-4.66-5.25-56.423-15.934-63.188-26.458a32.682,32.682,0,0,1-4.37-10.078,23.836,23.836,0,0,1-.32-10.86l51.695-1.494s43.051,26.8,47.915,45.072S1488.772,1110,1488.772,1110Z",
    transform: "translate(-966.991 636.854)",
    fill: "#6bb7bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_693",
    "data-name": "Path 693",
    d: "M1517.288,1063.2c-4.659-5.25-56.423-15.934-63.187-26.458a32.677,32.677,0,0,1-4.371-10.078v-6.544l21.972-3.455s6.229,19.163,24.676,26.361C1513.668,1049.766,1516.942,1061.716,1517.288,1063.2Z",
    transform: "translate(-969.17 630.21)",
    fill: "#5aa9ad"
  })), /*#__PURE__*/React.createElement("g", {
    id: "upper-body"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_695",
    "data-name": "Path 695",
    d: "M1442.7,678.254c1.5,20.147-.472,50.789,1.226,56.094,1.467,4.578,18.176,1.859,24.846.328,2.468-.564,5.457-1.373,8.547-2.328,8.615-2.667,18-6.476,19.008-9.3a2.145,2.145,0,0,0,.092-.326,2.582,2.582,0,0,0-.016-1.186c-.336-1.441-1.63-3-1.782-6.563-.17-3.985-.144-8.678-.294-13.724a16.3,16.3,0,0,0-.078-1.754v-.528c-.145-5.628-.438-11.55-.787-17.409-.215-3.675-.468-7.334-.756-10.831-.75-9.025-1.764-17.063-3.1-22.126-2.192-8.269-7.019-13.65-11.414-17.617l-3.179-2.727a18.345,18.345,0,0,1-11.55-1.536c-4.105-1.95-5.513-3.347-6.237-2.822C1447.754,631.208,1440.934,653.626,1442.7,678.254Z",
    transform: "translate(-963.78 919.96)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_696",
    "data-name": "Path 696",
    d: "M1506.524,818.926c8.615-2.667,18-6.476,19.008-9.3a2.1,2.1,0,0,0,.092-.326c0-.4,0-.788-.016-1.187-.336-1.441-1.63-3-1.782-6.563-.171-3.985-.145-8.678-.294-13.724a16.363,16.363,0,0,0-.079-1.753v-.528l-34.824-44.363S1465.214,789.917,1506.524,818.926Z",
    transform: "translate(-992.982 833.383)",
    fill: "#ed7d2b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "laptop"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "laptop-screen",
    width: 1.578,
    height: 41.302,
    transform: "translate(582.431 1633.287) rotate(-162)",
    fill: "#4a75cb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "laptop-body",
    width: 43.339,
    height: 2.594,
    transform: "translate(582.414 1633.318) rotate(-178.78)",
    fill: "#4a75cb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "right-hand"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_699",
    "data-name": "Path 699",
    d: "M1676,947.12s13.913,3.675,19.144,3.287,9.563-2.869,10.219-4.166,2.037-3.594-1.517-3.171-8.4,1.181-8.557.5,2.887-.62,2.887-.62.922-1.339-.239-1.389-4.544-.966-5.8-.339-2.418,2.951-3.334,2.853-11.652-4.835-11.652-4.835Z",
    transform: "translate(-1136.043 687.314)",
    fill: "#e49963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_700",
    "data-name": "Path 700",
    d: "M1488.18,669.99s1.646,56.129,13.973,62.507c6.082,3.15,33.548,11.813,41.791,13.275,0,0,2.218-1.423,2.467-8.2,0,0-28.219-14.062-31.747-20.4-5.25-9.432,7.822-35.283.929-44.363S1495.945,658.755,1488.18,669.99Z",
    transform: "translate(-997.526 890.662)",
    fill: "#f99746"
  })), /*#__PURE__*/React.createElement("g", {
    id: "head"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_698",
    "data-name": "Path 698",
    d: "M1534.209,533.667s-17.01-2.838-15.078-13.4,1.05-18.05,11.978-16.685,12.312,5.775,12.524,9.466S1538.684,534.134,1534.209,533.667Z",
    transform: "translate(-1020.239 1008.731)",
    fill: "#e49963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_701",
    "data-name": "Path 701",
    d: "M1510.76,504.645s-.194-3.625,2.042-5.7c0,0-.788-3.636.659-4.234s1.737,2.457,2.4,1.977a14.694,14.694,0,0,0,4.854-6.111c1.257-3.355,12.773.709,14.115,1.313s5.657-1.612,6.494-3.413a25.22,25.22,0,0,1-3.476-3.355c-1.079-1.438-8.626-11.143-19.162-8.387s-11.983,7.789-11.385,12.1S1506.441,503.2,1510.76,504.645Z",
    transform: "translate(-1011.541 1028.772)",
    fill: "#2b478b"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_723",
    "data-name": "Path 723",
    d: "M1418.395,1149.67c-3.252,20.838-24.518,34.11-46.332,34.11h-43.2l3.379-121.468s41.213-13.23,51.577-.643c9.069,11.025,33.666,54.672,34.96,80.507A36.29,36.29,0,0,1,1418.395,1149.67Z",
    transform: "translate(-880.028 601.03)",
    fill: "#f9ddbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_724",
    "data-name": "Path 724",
    d: "M1233,1080.892s58.276-29.747,69.322-10.317c5.862,10.319,21.993,51.483,23.182,77.315,1.157,25.1-20.588,41.607-42.959,41.607h-39.722Z",
    transform: "translate(-809.332 595.312)",
    fill: "#c6916d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_725",
    "data-name": "Path 725",
    d: "M921.153,881.768c-.491,2.528-5.211,4.872-12.214,6.948q-1.837.551-3.9,1.074c-23.833,6.087-66.046,9.484-70.07,7.691C829.406,895,795.28,773.75,795.28,773.75s32.574-1.223,58.444-1.819c8.852-.2,16.916-.331,22.623-.315a14.061,14.061,0,0,1,1.963.137,9.32,9.32,0,0,1,5.757,2.945c4.166,4.463,5.2,13.317,9.054,23.1,3.814,9.663,8.495,21.722,12.931,33.69,1.145,3.084,2.273,6.164,3.365,9.188q.464,1.284.919,2.554C916.893,861.579,921.946,877.671,921.153,881.768Z",
    transform: "translate(-486.515 810.937)",
    fill: "#efcbab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_726",
    "data-name": "Path 726",
    d: "M1480.234,1410.588c-3.252,20.838-24.518,34.11-46.332,34.11H1412.71C1426.844,1435.119,1439.622,1405.6,1480.234,1410.588Z",
    transform: "translate(-941.868 340.112)",
    fill: "#eac3a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "mary-shadow",
    d: "M1065.941,843.583c-1.084-.178-2.481-.407-4.066-.677a3.629,3.629,0,0,1-.745-1.018c-.638-1.4-.2-5.429.525-10.051-4.436-11.968-9.117-24.027-12.931-33.69-3.856-9.773-4.888-18.614-9.053-23.1a9.32,9.32,0,0,0-5.757-2.945c-3.439.047-7.069.108-10.815.178a16.8,16.8,0,0,1-7.584,7.214c-17.674,9.3-4.565,28.474-4.565,28.474.128.086,7.016,13.776,7.016,13.776-.026-.958.9-2.667,2.491-4.846a112.524,112.524,0,0,0,5.358,22.523c-1.247,6.318-4.463,15.732-6.169,22.932-1.373,5.741-1.8,10.07.47,10.283a5.334,5.334,0,0,0,.843,0,11.692,11.692,0,0,0,1.381,6.3c4.429,8.563,25.725,10.1,42.2,10.135,7-2.077,11.723-4.421,12.214-6.949C1077.551,878.028,1072.5,861.937,1065.941,843.583Z",
    transform: "translate(-642.12 810.579)",
    fill: "#e0b594"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_728",
    "data-name": "Path 728",
    d: "M1186.371,1209.91c-8.34,11.587-21.132,19.016-35.38,18.785l-61.26.031h-29.35l33.023-108.755s83.578-8.316,93.884,2.775c4.785,5.145,7.471,28.461,8.978,51.96A54.3,54.3,0,0,1,1186.371,1209.91Z",
    transform: "translate(-682.025 556.233)",
    fill: "#d39e7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_729",
    "data-name": "Path 729",
    d: "M1268.831,1460.825c-8.34,11.587-21.132,19.016-35.38,18.785l-61.26.031c7.208-6.038,29.881-23.224,54.155-22.41C1244.743,1457.851,1259.357,1457.586,1268.831,1460.825Z",
    transform: "translate(-764.484 305.318)",
    fill: "#c6916d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "mary"
  }, /*#__PURE__*/React.createElement("path", {
    id: "left-hand-2",
    "data-name": "left-hand",
    d: "M1226.525,838.47s5.09,7.531,7.993,23.363c2.541,13.866,4.77,18.987,8.442,21.83s24.13,11.24,24.13,11.24l-1.531,3.583s-29.983-4.084-33.351-9.1S1216,854.772,1217,847.954,1226.525,838.47,1226.525,838.47Z",
    transform: "translate(-797.488 761.632)",
    fill: "#f4a269"
  }), /*#__PURE__*/React.createElement("g", {
    id: "left-leg-2",
    "data-name": "left-leg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_731",
    "data-name": "Path 731",
    d: "M1528.615,1410.34c-.262,2.924,3.8,3.636,8.518,3.869s3.289,1.2,9.752,2.362,9.051-.6,9.519-1.47c.415-.787-2.588-1.987-5.791-3.355-.4-.171-.806-.349-1.21-.525-3.6-1.575-5.623-4.817-8.434-7.812-2.659-2.838-5.187-11.926-5.187-11.926L1527,1389.61s2.465,8.18,3.321,11.671c.5,2.053-.239,4.347-.9,6.1A11.54,11.54,0,0,0,1528.615,1410.34Z",
    transform: "translate(-1026.156 355.168)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_732",
    "data-name": "Path 732",
    d: "M1541.633,1464.123c4.725.234,3.289,1.2,9.752,2.363s9.051-.6,9.518-1.47c.415-.788-2.588-1.987-5.791-3.355l-.05.052a18.4,18.4,0,0,1-9.786.118c-4.276-1.16-8.4-3.715-11.353-4.542a11.534,11.534,0,0,0-.809,2.956C1532.847,1463.178,1536.916,1463.889,1541.633,1464.123Z",
    transform: "translate(-1030.656 305.254)",
    fill: "#c65447"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_733",
    "data-name": "Path 733",
    d: "M1167.867,1053.389s58.352-4.392,69.335,2.541,28.613,87.676,28.613,87.676a7.144,7.144,0,0,1-3.518,1.137c-2.257.244-7.232-1.084-7.232-1.084s-25.318-36.133-27.1-45.235-1.347-17.225-5.407-17.443-54.688,6.156-62.345-7.334-1.312-26.846-1.312-26.846Z",
    transform: "translate(-752.861 607.989)",
    fill: "#163560"
  })), /*#__PURE__*/React.createElement("g", {
    id: "right-leg-2",
    "data-name": "right-leg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_734",
    "data-name": "Path 734",
    d: "M1443.594,1446.04c-.263,2.924,3.8,3.636,8.516,3.869s3.289,1.2,9.752,2.362,9.051-.6,9.518-1.47c.417-.788-2.588-1.987-5.775-3.355-.4-.171-.806-.346-1.21-.525-3.6-1.575-5.625-4.814-8.434-7.812-2.662-2.838-5.187-11.923-5.187-11.923l-8.784-1.877s2.468,8.18,3.323,11.671c.5,2.053-.239,4.35-.9,6.1A11.463,11.463,0,0,0,1443.594,1446.04Z",
    transform: "translate(-963.461 328.839)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_735",
    "data-name": "Path 735",
    d: "M1456.614,1499.8c4.725.236,3.289,1.2,9.752,2.362s9.051-.6,9.518-1.47c.417-.787-2.588-1.987-5.775-3.355l-.05.055a18.418,18.418,0,0,1-9.789.115c-4.274-1.16-8.4-3.715-11.354-4.542a11.48,11.48,0,0,0-.806,2.956C1447.827,1498.863,1451.9,1499.575,1456.614,1499.8Z",
    transform: "translate(-967.965 278.94)",
    fill: "#c65447"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_736",
    "data-name": "Path 736",
    d: "M1110.152,1085.68s51.842,2.446,62.541,9.8,25.169,88.726,25.169,88.726a7.162,7.162,0,0,1-3.557,1c-2.268.155-7.187-1.365-7.187-1.365s-23.888-37.089-25.321-46.256-.677-17.262-4.725-17.638-54.884,4.019-62.011-9.757S1110.152,1085.68,1110.152,1085.68Z",
    transform: "translate(-706.563 579.315)",
    fill: "#1c468a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "hair",
    d: "M1087.427,642.177a13.432,13.432,0,0,0-7.166-1.872,3.388,3.388,0,0,1,1.575-.625c-1.231-.262-4.087.788-4.087.788-16.842-7.812-21.262,17.457-21.286,23.394s-.444,12.747-9.427,17.475c-17.674,9.3-4.562,28.474-4.562,28.474.129.087,7.017,13.776,7.017,13.776-.118-4.806,23.609-28.553,35.616-35.338,3.074-3.937,4.554-11.151,4.667-11.721-.869,5.744-2.071,8.925-3.077,10.681C1097.041,678.888,1093.526,646.2,1087.427,642.177Z",
    transform: "translate(-665.368 908.752)",
    fill: "#b5453c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1271",
    "data-name": "Path 1271",
    d: "M1147.991,805.42s4.575.2,9.4.656c3.279.312,6.781.672,8.629,1.446,4.568,1.908,4.09,10-5.5,8.5S1147.319,807.817,1147.991,805.42Z",
    transform: "translate(-746.58 786.006)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "neck-2",
    "data-name": "neck"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_739",
    "data-name": "Path 739",
    d: "M1167.094,777.394c.055.029,1.368,6.956-4.909,6.681-4.121-.181-13.007-5.169-12.222-8.7.373-1.677,3.486-6.038,4.111-15.958l.751.2L1167.438,763s-.559,4-.821,7.791C1166.4,773.973,1166.388,777.005,1167.094,777.394Z",
    transform: "translate(-748.057 819.93)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_740",
    "data-name": "Path 740",
    d: "M1181.233,763.564s-.559,4-.822,7.791c-7.137-.68-10.484-7.455-11.792-11.175Z",
    transform: "translate(-761.852 819.37)",
    fill: "#f4a269"
  })), /*#__PURE__*/React.createElement("g", {
    id: "face"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_742",
    "data-name": "Path 742",
    d: "M1179.176,705.778s-16.939-.848-16.236-11.377-1.032-17.75,9.812-17.653,12.682,4.258,13.306,7.831S1183.6,705.728,1179.176,705.778Z",
    transform: "translate(-757.647 880.902)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_743",
    "data-name": "Path 743",
    d: "M1165.49,670.824s-5.457,12.057-12.689,13.409-10.19-.756-10.19-.756a20.176,20.176,0,0,0,7.379-11.456S1162.4,664.7,1165.49,670.824Z",
    transform: "translate(-742.67 887.07)",
    fill: "#b5453c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_744",
    "data-name": "Path 744",
    d: "M1225.14,676.089s3.276,2.99,3.938,5.73.674,8.292,2.3,8.211c0,0,4.05-8.172.444-13.188C1227.991,671.524,1225.14,676.089,1225.14,676.089Z",
    transform: "translate(-803.535 882.731)",
    fill: "#b5453c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "upper-body-2",
    "data-name": "upper-body"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_745",
    "data-name": "Path 745",
    d: "M1138.242,876.232c-1.37,1.638-5.652,2.142-10.238,2.888-3.6.593-7.381,1.339-10.072,2.919-6.106,3.583-26.056,15.7-31.9,15.149-2.268-.213-1.837-4.542-.47-10.282,2.16-9.07,6.686-21.662,6.686-27.138,0-2.99.995-10.062,2.321-18.147.107-.651.218-1.313.328-1.971,2.625-15.722,6.266-34.26,6.266-34.26s4.058,8.854,11.963,8.854,6.069-6.752,6.069-6.752,7.213.848,8.925,2.683,6.038,9.77,6.885,11.936c0,0,.173,2.754-6.644,4.064a89.444,89.444,0,0,1,1.859,12.458c.145,3.675-2.512,15.2-3.276,22.365-.262,2.538-.307,4.531.105,5.434.525,1.158,2.234,2.31,4.174,3.442C1135.078,872.124,1139.869,874.284,1138.242,876.232Z",
    transform: "translate(-699.764 786.028)",
    fill: "#1c468a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_746",
    "data-name": "Path 746",
    d: "M1131.262,952.725c4.376,7.46-11.868,9.713-14.556,11.288-6.106,3.583-24.78,16.582-30.626,16.031-2.268-.213-1.837-4.541-.47-10.282,2.16-9.07,6.686-21.662,6.686-27.138,0-2.99.995-10.062,2.32-18.147l7.041-6.757s7.542,19.491,14.729,22.686a60.442,60.442,0,0,0,10.6,3.449c-.263,2.538-.307,4.531.1,5.434C1127.615,950.441,1129.322,951.594,1131.262,952.725Z",
    transform: "translate(-699.8 703.185)",
    fill: "#163560"
  })), /*#__PURE__*/React.createElement("g", {
    id: "right-hand-2",
    "data-name": "right-hand"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_747",
    "data-name": "Path 747",
    d: "M1101.866,824.946s-6.019-3.654-11.836,3.279,4.134,56.491,12.757,59.037c9.576,2.827,37.242-.454,37.242-.454l-.525-4.323s-29.453-5.646-30.676-7.219S1104.916,825.745,1101.866,824.946Z",
    transform: "translate(-702.611 772.315)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_752",
    "data-name": "Path 752",
    d: "M1274.16,1041.746s9.589-1.856,10.673-1.394,7.114,5.877,6.494,6.962-3.092,1.856-5.877.927-8.815-1.392-9.9-2.783A9.118,9.118,0,0,1,1274.16,1041.746Z",
    transform: "translate(-839.688 612.798)",
    fill: "#ffb27d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "right-hand-sleeve",
    d: "M1090.368,805.42s-12.359,1.113-15.947,5.179-4.641,15.081-4.641,15.081,10.886,8.786,24,5.376Z",
    transform: "translate(-688.958 786.006)",
    fill: "#1c468a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "laptop-2",
    "data-name": "laptop"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "laptop-body-2",
    "data-name": "laptop-body",
    width: 16.325,
    height: 1.929,
    transform: "translate(440.298 1661.441)",
    fill: "#9e332e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "laptop-screen-2",
    "data-name": "laptop-screen"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_749",
    "data-name": "Path 749",
    d: "M1345.33,1011.191c.16-.638,15.007-23.951,15.007-23.951h33.036l-16.572,23.323Z",
    transform: "translate(-892.175 651.914)",
    fill: "#9e332e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_750",
    "data-name": "Path 750",
    d: "M1350.63,1011.456c.16-.64,15.055-24.216,15.055-24.216h31.6l-15.766,24.216Z",
    transform: "translate(-896.084 651.914)",
    fill: "#b5453c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_751",
    "data-name": "Path 751",
    d: "M1446.852,1028.852a2.64,2.64,0,0,1-2.3,1.712,1.179,1.179,0,0,1-1.121-1.712,2.64,2.64,0,0,1,2.3-1.711A1.177,1.177,0,0,1,1446.852,1028.852Z",
    transform: "translate(-964.451 622.488)",
    fill: "#9e332e"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_753",
    "data-name": "Path 753",
    d: "M1116.164,1150.76c-3.5,20.213-22.728,33.02-42.434,33.02H1034l3.108-121.468s37.905-13.23,47.426-.643c8.342,11.025,30.976,54.672,32.154,80.507A39.305,39.305,0,0,1,1116.164,1150.76Z",
    transform: "translate(-662.57 601.03)",
    fill: "#f9ddbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_754",
    "data-name": "Path 754",
    d: "M1138.421,1414.688c-3.5,20.213-22.728,33.02-42.434,33.02H1064.18C1079.064,1437.623,1099.1,1409.75,1138.421,1414.688Z",
    transform: "translate(-684.828 337.101)",
    fill: "#eac3a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_755",
    "data-name": "Path 755",
    d: "M775.982,972.64c-.3.021-.593.039-.893.055q-.942.05-1.89.066H732.847v-.018l-2.294.029c-4.092.05-8.363.1-12.338.131l-1.964.016h-.714c-3.917.026-7.379.039-9.849.021a65.663,65.663,0,0,1-9.826-.756,43.877,43.877,0,0,1-10.949-3.132,35.827,35.827,0,0,1-3.483-1.769,34.4,34.4,0,0,1-4.31-2.94,39.041,39.041,0,0,1-9.167-10.763,58.89,58.89,0,0,1-4.759-10.377,100.414,100.414,0,0,1-4.182-16.653,216.735,216.735,0,0,1-2.662-31.359q-.157-7.264-.023-15.328.212-12.892,1.15-27.917c.874-14.086,2.208-29.621,3.972-46.726,1.607-15.619,3.462-26.539,6.161-29.025,3.98-3.675,12.283-5.145,18.058-5.738h0c3.586-.367,6.19-.4,6.19-.4,7.056,0,13.327,5.066,15.593,12.6,4.61,15.328,12.842,42.733,21.41,71.4.042.144.087.289.129.433l1.478,4.951.228.753c.483-.215.982-.441,1.5-.667a.245.245,0,0,1,.053-.026c2.053-.908,4.378-1.906,6.885-2.922h0c1.313-.525,2.649-1.05,4.04-1.593,3.919-1.5,8.138-2.99,12.443-4.268,1.9-.572,3.82-1.1,5.725-1.575,2.447-.606,4.875-1.121,7.24-1.5l.2-.034.837-.126c10.2-1.5,19.052-.457,22.717,6,5.862,10.348,21.99,51.632,23.179,77.541C816.63,954.928,797.095,971.054,775.982,972.64Z",
    transform: "translate(-383.992 812.083)",
    fill: "#d39e7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_756",
    "data-name": "Path 756",
    d: "M794.829,865.152s-20.391-83.08-21.864-90.062a5.274,5.274,0,0,0-4.725-4.525c3.583-.368,6.19-.394,6.19-.394,7.056,0,13.327,5.051,15.593,12.556,4.938,16.37,14.031,46.56,23.245,77.307C812.8,860.009,794.829,865.152,794.829,865.152Z",
    transform: "translate(-466.573 812.003)",
    fill: "#f9ddbf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "synia"
  }, /*#__PURE__*/React.createElement("g", {
    id: "left-leg-3",
    "data-name": "left-leg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_703",
    "data-name": "Path 703",
    d: "M559.439,1048.088l-4.817,2.557s-26.04-27.613-32.3-54.107a41.027,41.027,0,0,1-1.089-13.823s-.378-1.2-1.05-3.321c-.029-.094-.06-.189-.089-.284-.289-.932-.638-2.026-1.024-3.265-1.257-4.006-2.985-9.484-4.951-15.721-4.534-14.354-14.9-46.726-19.328-60.195l31.836-11.519s3.615,8.245,8.812,30.661c.8,2.924,1.6,6.158,2.363,9.684.851,3.993,1.643,8.358,2.3,13.073a201.108,201.108,0,0,1,1.908,26.838c.018,4.008-.081,8.169-.318,12.458a54.649,54.649,0,0,0,1.171,12.109C546.873,1015.039,559.439,1048.088,559.439,1048.088Z",
    transform: "translate(-264.905 724.801)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_704",
    "data-name": "Path 704",
    d: "M734.391,1505.654H708.652s-.963-4.106.727-6.9c1.5-2.473.921-3.88-.186-5.925a10,10,0,0,0,4.337.816,9.136,9.136,0,0,0,3.827-1.347c1.108,1.263,5.851,6.639,7.334,7.7C726.371,1501.212,733.873,1500.782,734.391,1505.654Z",
    transform: "translate(-422.426 279.434)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_705",
    "data-name": "Path 705",
    d: "M540.13,941.8l-20,37.276c-.289-.932-.638-2.027-1.024-3.266-1.257-4.006-2.985-9.484-4.951-15.721-4.534-14.354-14.9-46.726-19.328-60.195l31.836-11.519s3.615,8.245,8.812,30.66c.8,2.924,1.6,6.158,2.362,9.684C538.679,932.725,539.471,937.09,540.13,941.8Z",
    transform: "translate(-264.935 724.823)",
    fill: "#233862"
  })), /*#__PURE__*/React.createElement("path", {
    id: "right-hand-3",
    "data-name": "right-hand",
    d: "M303.865,738.057c-.16.139-7.791-7.66-11.865-11.981l4.082-2.486,22.281,13.989Z",
    transform: "translate(-115.348 846.355)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "full-head"
  }, /*#__PURE__*/React.createElement("path", {
    id: "hair-2",
    "data-name": "hair",
    d: "M515.452,410.034c.144-.682,1.961-7.983,13.291-6.408,0,0-5.654-.3-7.032,1.964,0,0,4.294-2.363,7.2-.851s3.77,7.2,3.481,8.97-3,7.177-5.022,7.324a6.062,6.062,0,0,1-2.363-.407,26.456,26.456,0,0,1,1.05,2.964c2.888,10.007-3.313,18.215-6.943,16.556-2.329-1.05-3.743,2.979-3.743,2.979L495,419.81S506.834,403.311,515.452,410.034Z",
    transform: "translate(-265.06 1082.491)",
    fill: "#2c3a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "neck-3",
    "data-name": "neck"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_709",
    "data-name": "Path 709",
    d: "M493.52,577.721a29.164,29.164,0,0,0,10.169,4.326c15.674,3.622,21.68-9.626,23.935-18.719a13.477,13.477,0,0,0-5.31-1.633c-1.131-.131-2.323-.221-3.31-.263-1.759-1.347-4.381-6.864-4.961-15.433l-.737.2-12.354,3.381s.564,3.938.843,7.639c.215,2.9.247,5.678-.3,6.358-.963.21-1.544.346-1.544.346h0a79.5,79.5,0,0,0-6.429,13.8Z",
    transform: "translate(-263.968 977.327)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_710",
    "data-name": "Path 710",
    d: "M521.83,550.1s.567,3.924.843,7.639c7-.7,10.237-7.363,11.511-11.025Z",
    transform: "translate(-284.847 976.803)",
    fill: "#ed985f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "face-2",
    "data-name": "face"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_711",
    "data-name": "Path 711",
    d: "M494.434,493.525s16.614-.916,15.884-11.253.921-17.415-9.713-17.268-12.416,4.237-13.012,7.747S490.1,493.5,494.434,493.525Z",
    transform: "translate(-259.543 1037.063)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_712",
    "data-name": "Path 712",
    d: "M484.051,460.981c2.336-3.281,4.329-2.756,5.486-1.9A11.628,11.628,0,0,1,504.62,460.4a19.827,19.827,0,0,0,7.29,11.214s-2.888,2.084-9.991.788a11.9,11.9,0,0,1-5.927-3.494,38.788,38.788,0,0,0,7.245,7.66c-8.6-3.252-12.779-14.6-13.2-15.795-.948.982-2.8,3.1-3.273,5.08-.638,2.693-.622,8.138-2.213,8.067C484.549,473.915,480.538,465.919,484.051,460.981Z",
    transform: "translate(-255.922 1043.052)",
    fill: "#2c3a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "right-leg-3",
    "data-name": "right-leg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_707",
    "data-name": "Path 707",
    d: "M492.559,1509.233a16.653,16.653,0,0,0,1.079,8.056H504.3a13.447,13.447,0,0,0-2.638-7.177C498.948,1506.12,492.559,1509.233,492.559,1509.233Z",
    transform: "translate(-263.183 267.799)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_714",
    "data-name": "Path 714",
    d: "M455.1,881.8s-.032.278-.087.809c-.024.228-.055.5-.087.824-.228,2.126-.659,6.206-1.215,11.508-1.452,13.913-3.733,36.249-5.284,53.882-1.215,13.789-1.987,24.7-1.575,26.452,1.252,5.271,0,68.3,0,68.3-4.5,2.158-11.319,0-11.319,0s-11.983-56.8-10.306-64.691a27.185,27.185,0,0,0-1.121-14.632c-9.3-43.313-8.285-67.34-6.437-78.835a48.255,48.255,0,0,1,1.591-7.019,14.3,14.3,0,0,1,.638-1.725A43.79,43.79,0,0,1,455.1,881.8Z",
    transform: "translate(-207.123 734.633)",
    fill: "#2b478b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1272",
    "data-name": "Path 1272",
    d: "M475.748,894.972a52.261,52.261,0,0,1-18.562,4.011,62.273,62.273,0,0,1-15.275-1.449,70.475,70.475,0,0,1-20.762-8.077,48.253,48.253,0,0,1,1.591-7.019c6.245-4.447,21.7-.184,34.314,4.541q.677.262,1.347.509C468.067,891.179,475.748,894.972,475.748,894.972Z",
    transform: "translate(-210.596 730.587)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("g", {
    id: "body"
  }, /*#__PURE__*/React.createElement("path", {
    id: "body-2",
    "data-name": "body",
    d: "M409.585,633.255c-1.312,9.867-6.534,21.94-8.4,28.44,0,0,3.121,22.575.142,28.76a2.74,2.74,0,0,1-1.271,1.423c-11.025,4.807-54.013.139-55.827-13.726-.648-5.03,16.37-22.756,17.362-24.906.412-.887.851-3.772-1.147-9.747-2.83,8.725-8.056,18.8-13.314,20.52-5.775,1.89-28.613-15.133-28.613-15.133s-.131-2.068,2.756-4.024c1.856-1.258,6.122-1.683,6.122-1.683l14.611,6.536c1.838-3.15,6.4-24.838,11.5-34.635,3.835-7.366,14.073-8.432,14.073-8.432s4.26,6.76,14.564,5.8,12.191-7.266,12.191-7.266,9.14,1.215,11.954,3.489C406.766,609.07,411.307,620.329,409.585,633.255Z",
    transform: "translate(-134.904 933.682)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_717",
    "data-name": "Path 717",
    d: "M589.12,740.57s3.121,22.575.142,28.76c-8.041-4.037-18.52-12.747-15.33-26.361,4.633-19.775,23.589-30.839,23.589-30.839C596.215,722,590.986,734.07,589.12,740.57Z",
    transform: "translate(-322.839 854.807)",
    fill: "#ed7d2b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1273",
    "data-name": "Path 1273",
    d: "M607.727,760.98l-11.135.452-3.812,5.192,15.146.507Z",
    transform: "translate(-337.172 818.78)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "left-hand-3",
    "data-name": "left-hand"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_718",
    "data-name": "Path 718",
    d: "M562.158,762.7s-11.445,1.659-12.359,2.512-4.071,5.82-3.675,7.544.349,3.507,1.05,3.386,2.987-4.512,3.851-4.725,1.575-.787,1.68-.407-1.756,2.231-1.664,2.757,1.557-.089,2.215-1.108,2.3-1.522,2.549-2.158,1.381-2.735,2.922-2.638S562.158,762.7,562.158,762.7Z",
    transform: "translate(-302.738 817.512)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_720",
    "data-name": "Path 720",
    d: "M607.3,605.18s13.272,1.575,16.929,7.266c4.62,7.2,20.945,31.065,20.594,38.286,0,0-10.169,4.053-37.512,1.88,0,0-.5-4.134,5.25-7.453,0,0,14.679-2.011,16.3-3.436l-10.9-11.579Z",
    transform: "translate(-347.88 933.682)",
    fill: "#f99746"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mobile"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_702",
    "data-name": "Path 702",
    d: "M298.43,664.068l9.075-.869a1.667,1.667,0,0,1,1.7,1.021l6.851,16.493a1.667,1.667,0,0,1-1.381,2.3l-9.45.9a1.67,1.67,0,0,1-1.709-1.05l-6.487-16.538a1.667,1.667,0,0,1,1.4-2.258Z",
    transform: "translate(-118.975 890.899)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_721",
    "data-name": "Path 721",
    d: "M290.907,664.754l9.075-.866a1.662,1.662,0,0,1,1.7,1.018l6.854,16.493a1.667,1.667,0,0,1-1.381,2.3l-9.45.9a1.664,1.664,0,0,1-1.709-1.05l-6.484-16.538a1.667,1.667,0,0,1,1.4-2.258Z",
    transform: "translate(-113.429 890.391)",
    fill: "#2b478b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "right-finger",
    d: "M285.749,699.164s-2.394-4.135-2.216-5.153,2.659-5.741,3.938-6.211c2.276-.84,5.471-1.357,4.594,1.05-.58,1.575-2.888,3.875-2.478,4.591s.247,3.247.247,3.247Z",
    transform: "translate(-109.097 873.267)",
    fill: "#ffb27d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "juliet-shadow",
    d: "M996.063,1122.555c-5.457-9.022-.874-10.713-1.712-30.92S984.114,1073.1,980.2,1069.19a10.633,10.633,0,0,1-1.893-4.15l-.838.126-.2.034c-2.363.381-4.793.9-7.24,1.5-1.906.47-3.822,1-5.725,1.575-4.292,1.278-8.523,2.764-12.443,4.268-1.391.525-2.738,1.066-4.04,1.594-3.376,21.2-8.6,116.189-8.6,116.189l.126.131c4.266-.04,8.878-.089,13.262-.142l1.864-.024v.019h29.981c.042-.021.081-.047.123-.071l.081-.05c8.054-4.988,6.255-15.015,4.36-21.3-.766-6.718-3.733-14.585-6.158-21.9.753-2.226,1.811-3.5,6.347-5.174,5.04-1.859,6.363-9.792,6.363-9.792,1.347,3.549-1.733,8.445-1.814,8.573C993.931,1140.392,1001.46,1131.47,996.063,1122.555Z",
    transform: "translate(-592.67 594.537)",
    fill: "#c6916d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "juliet"
  }, /*#__PURE__*/React.createElement("path", {
    id: "right-hand-4",
    "data-name": "right-hand",
    d: "M689.72,1128.14s-30.248,13.178-35.737,12.939-39.323-10.306-39.323-10.306l.861,5.822s26.109,15.016,35.236,15.869c8.988.837,39.717-8.067,42.683-9.946S698.341,1130.043,689.72,1128.14Z",
    transform: "translate(-353.309 548.001)",
    fill: "#ed985f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hair-3",
    "data-name": "hair",
    d: "M872.193,941.907s11.159-2.118,16.716,1.94c10.067,7.35,10.608,32.7,14.38,36.472s12.863,2.166,13.679,21.7-3.622,21.168,1.654,29.889-2.231,17.449-2.231,17.449,3.074-4.812,1.756-8.287c0,0-1.278,7.668-6.151,9.466s-5.594,3.116-6.371,5.751c0,0-41.562-21.3-41.607-36.4s-8.18-30.062-4.187-36.624a14.492,14.492,0,0,0-1.995,5.917,7.79,7.79,0,0,1,1.756-8.867c4.153-4.274-4.872-13.125-3.536-23.363C856.976,949.924,861.911,942.215,872.193,941.907Z",
    transform: "translate(-531.237 685.754)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("g", {
    id: "neck-4",
    "data-name": "neck"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_760",
    "data-name": "Path 760",
    d: "M886.59,1093.9a29.21,29.21,0,0,0,10.169,4.329c15.674,3.62,21.683-9.629,23.938-18.721a13.47,13.47,0,0,0-5.311-1.63c-1.134-.134-2.326-.223-3.31-.262-1.761-1.347-4.384-6.865-4.964-15.43l-.738.2-12.353,3.381s.567,3.938.845,7.639c.213,2.9.247,5.681-.3,6.358-.963.21-1.541.347-1.541.347A79.375,79.375,0,0,0,886.59,1093.9Z",
    transform: "translate(-553.856 596.646)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_761",
    "data-name": "Path 761",
    d: "M914.9,1066.236s.567,3.938.843,7.639c7-.7,10.238-7.366,11.511-11.025Z",
    transform: "translate(-574.734 596.152)",
    fill: "#ed985f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "face-3",
    "data-name": "face"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_762",
    "data-name": "Path 762",
    d: "M887.507,1009.655s16.611-.916,15.882-11.254.924-17.414-9.713-17.268-12.416,4.239-13.012,7.749S883.168,1009.626,887.507,1009.655Z",
    transform: "translate(-549.432 656.419)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_763",
    "data-name": "Path 763",
    d: "M874.2,977.119c2.342-3.294,4.329-2.751,5.481-1.893a11.632,11.632,0,0,1,15.086,1.312,19.727,19.727,0,0,0,7.292,11.2s-2.888,2.084-9.975.788a11.889,11.889,0,0,1-5.927-3.491,38.816,38.816,0,0,0,7.245,7.657c-8.6-3.252-12.779-14.595-13.2-15.795-.947.982-2.8,3.1-3.271,5.082-.638,2.691-3.394,6.9-4.987,6.825C871.935,988.816,870.69,982.057,874.2,977.119Z",
    transform: "translate(-542.892 662.4)",
    fill: "#233862"
  })), /*#__PURE__*/React.createElement("g", {
    id: "body-3",
    "data-name": "body"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_764",
    "data-name": "Path 764",
    d: "M896.938,1166.073c1.5-7.668,6.392-38.307,1.5-48.166-1.756-3.541-8.663-3.862-16.212-3.552-2.362,1.52-11.322,7.261-15,6.544a1.4,1.4,0,0,1-.207-.047c-1.733-.433-2.389-1.654-.943-2.7a33.1,33.1,0,0,0-8.4.525c-2.625.5-9.712,4.163-9.712,4.163s3.57,6.447,8.83,8.663c-.9,8.006.436,11.537,8.739,30.025,7.017,15.627-.945,29.7-.945,29.7s41.3,33.209,41.536,16.3C906.3,1194.783,895.022,1175.883,896.938,1166.073Z",
    transform: "translate(-525.367 558.234)",
    fill: "#b5453c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_767",
    "data-name": "Path 767",
    d: "M914.885,1158.74s3.349,30.477-18.375,36.863-27.88-28.043-10.353-30.519A169.255,169.255,0,0,0,914.885,1158.74Z",
    transform: "translate(-546.025 525.433)",
    fill: "#9e332e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "right-leg-4",
    "data-name": "right-leg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_765",
    "data-name": "Path 765",
    d: "M794.973,1289.747a7.683,7.683,0,0,1-5.512-3.365q-.3-.446-.638-.961c-4.7-7.117-6.531-28.915-17.107-52.139-2.575-5.652-11.813-6.67-14.343-13.06,0,0-6.206-20.714,11.878-21.326s48.429,57.633,48.9,63.744C818.612,1268.557,830.1,1293.708,794.973,1289.747Z",
    transform: "translate(-457.801 495.822)",
    fill: "#dd6d22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_766",
    "data-name": "Path 766",
    d: "M629.69,1505.654h25.725s.964-4.106-.727-6.9c-1.5-2.473-.924-3.88.184-5.925a9.986,9.986,0,0,1-4.334.816,9.122,9.122,0,0,1-3.827-1.347c-1.108,1.263-5.851,6.639-7.335,7.7C637.707,1501.212,630.207,1500.782,629.69,1505.654Z",
    transform: "translate(-364.394 279.434)",
    fill: "#9e332e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_768",
    "data-name": "Path 768",
    d: "M704.911,1202.565c-1.551,11.618-7.613,48.3-18.281,66.185-3.442,5.775,8.663,9,8.739,8.985,1.625-.425,4.331-3.016,5.578-4.14,8.663-7.812,26.25-29.926,26.25-47.665,0-8.647.152-25.161-6.135-29.358C717.2,1193.979,705.517,1197.95,704.911,1202.565Z",
    transform: "translate(-405.933 498.138)",
    fill: "#ed7d2b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "left-leg-4",
    "data-name": "left-leg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_769",
    "data-name": "Path 769",
    d: "M853.5,1285.542s-.956-1.328-2.625-3.849c-1.979-3-4.171-8.9-6.825-16.461-2.793-7.941-6.106-17.708-10.238-27.87-1.278-3.15-2.625-6.313-4.077-9.484-2.575-5.654-9.663-4.872-12.183-11.264,0,0-9.839-22.155,8.245-22.767s52.448,59.268,54.422,65.069C882.377,1265.264,892.922,1291.625,853.5,1285.542Z",
    transform: "translate(-500.972 499.545)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_770",
    "data-name": "Path 770",
    d: "M701.67,1505.654h25.738s.961-4.106-.727-6.9c-1.5-2.473-.924-3.88.184-5.925a10,10,0,0,1-4.334.816,9.122,9.122,0,0,1-3.827-1.347c-1.108,1.263-5.854,6.639-7.334,7.7C709.687,1501.212,702.187,1500.782,701.67,1505.654Z",
    transform: "translate(-417.479 279.434)",
    fill: "#b5453c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_771",
    "data-name": "Path 771",
    d: "M897.238,1339.312c-2.793-7.941-6.106-17.708-10.238-27.87,1.081-7.7,3.412-14.438,7.332-17.152C894.324,1294.29,903.837,1323.756,897.238,1339.312Z",
    transform: "translate(-554.158 425.466)",
    fill: "#ed7d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_772",
    "data-name": "Path 772",
    d: "M772.989,1203.044c-1.549,11.619-3.733,49.117-14.409,67.009-3.441,5.775,8.663,9,8.739,8.986,1.625-.425,4.331-3.016,5.578-4.14,8.663-7.812,26.25-29.925,26.25-47.665,0-8.647-10.148-24.468-16.435-28.665A6.318,6.318,0,0,0,772.989,1203.044Z",
    transform: "translate(-458.995 496.835)",
    fill: "#f99746"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ipad"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_773",
    "data-name": "Path 773",
    d: "M598.681,1073.242l26.361-2.8a1.7,1.7,0,0,1,1.769,1.087l9.408,24.778a1.7,1.7,0,0,1-1.523,2.3l-26.156,1.05a1.7,1.7,0,0,1-1.638-1.05l-9.634-23.037a1.7,1.7,0,0,1,1.412-2.334Z",
    transform: "translate(-340.39 590.559)",
    fill: "#9e332e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_774",
    "data-name": "Path 774",
    d: "M589.95,1074.154l26.358-2.8a1.7,1.7,0,0,1,1.772,1.087l9.429,24.783a1.7,1.7,0,0,1-1.52,2.305l-26.156,1.05a1.7,1.7,0,0,1-1.638-1.05l-9.636-23.024a1.7,1.7,0,0,1,1.391-2.35Z",
    transform: "translate(-333.961 589.888)",
    fill: "#b5453c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_775",
    "data-name": "Path 775",
    d: "M649.6,1121.621a1.084,1.084,0,0,1,1.019-1.6,2.537,2.537,0,0,1,2.184,1.6,1.085,1.085,0,0,1-1.018,1.6A2.533,2.533,0,0,1,649.6,1121.621Z",
    transform: "translate(-379 553.989)",
    fill: "#9e332e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_776",
    "data-name": "Path 776",
    d: "M597.088,1088.788a.533.533,0,0,1,.5-.787,1.244,1.244,0,0,1,1.074.787.533.533,0,0,1-.5.787A1.249,1.249,0,0,1,597.088,1088.788Z",
    transform: "translate(-340.313 577.604)",
    fill: "#9e332e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "right-finger-2",
    "data-name": "right-finger"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_780",
    "data-name": "Path 780",
    d: "M604.288,1117.623s2.643-4.182,3.51-4.352c2.625-.525,2.625,2.951,2.076,5.19-.6,2.4-2.625,4.67-3.192,4.463S603.666,1119.823,604.288,1117.623Z",
    transform: "translate(-345.585 559.006)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_781",
    "data-name": "Path 781",
    d: "M604.01,1133.15a7,7,0,0,0,3.61,7.14Z",
    transform: "translate(-345.407 544.306)",
    fill: "#ffb27d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "left-hand-4",
    "data-name": "left-hand"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_777",
    "data-name": "Path 777",
    d: "M798.2,1128.14s-36.533,13.453-42.022,13.178c-3.549-.179-33.039-10.545-33.039-10.545l-2.648,5.008s28.7,18.449,36.6,18.359c15.579-.181,41.867-9.744,44.833-11.624S806.82,1130.043,798.2,1128.14Z",
    transform: "translate(-431.358 548.001)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_778",
    "data-name": "Path 778",
    d: "M677.355,1126.354s-2.649-4.074-5.284-4.2-7.19,1.8-8.747,2.1-5.99,1.735-4.672,3.893,7.429,2.625,10.064,2.158,5.99,1.05,5.99,1.05Z",
    transform: "translate(-385.574 552.42)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_779",
    "data-name": "Path 779",
    d: "M695.543,1115.888s-4.2-1.924-5.389-2.284-.958,0-.6,1.142,2.515,2.218,2.515,2.575S695.543,1115.888,695.543,1115.888Z",
    transform: "translate(-408.33 558.82)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_783",
    "data-name": "Path 783",
    d: "M944.82,1132.411s3.268,10.343,14.488,12.7c0,0,18.533-5.709,9.306-18.333C968.613,1126.788,959.491,1120,944.82,1132.411Z",
    transform: "translate(-596.801 550.366)",
    fill: "#b5453c"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndividualOffer);
export default __webpack_public_path__ + "static/media/individual-offer.3787f2320f5b5933de858619702c4c51.svg";
export { ForwardRef as ReactComponent };